module.exports = __webpack_public_path__ + "img/treatment-bg.00e3911c.png";